export default __webpack_public_path__ + "static/media/image-europa.3e95f7d0.png";